import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseButtonSizeEnum } from '../../base-button/base-button-size.enum';
import { SystemBanner } from '../../../../../models/shared/system-banner';

@Component({
  selector: 'app-vb-payments-overview-card',
  templateUrl: './vb-payments-overview-card.component.html',
  styleUrls: ['./vb-payments-overview-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsOverviewCardComponent {
  @Input() disableUpdateButton = false;
  @Input() banner: SystemBanner | null = null;

  @Output() updatePayments = new EventEmitter<void>();
  @Output() goToSubmission = new EventEmitter<void>();

  public isCollapsed = true;

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
